/*
 * @Author: your name
 * @Date: 2021-08-12 09:28:35
 * @LastEditTime: 2022-12-21 17:51:41
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\packages\index.js
 */
import BjImportFile from './BjImportFile';
import BjDialogList from './BjDialogList';
import BjDivider from './BjDivider';
import BjDrawerForm from './BjDrawerForm';
import BjSelectLov from './BjSelectLov';
import BjCheckboxLov from './BjCheckboxLov';
import BjRadioLov from './BjRadioLov';
import BjRouteTabs from './BjRouteTabs';
import BjInputMoney from './BjInputMoney';
import BjInput from './BjInput';
import ScrollLoad from './ScrollLoad';
import ScrollSelect from './ScrollSelect';
import BjPagingTable from './BjPagingTable';
import BjSelectProvinces from './BjSelectProvinces';
import BjInputNumber from './BjInputNumber';
import BjSelectChinaArea from './BjSelectChinaArea';
import BjUpload from './BjUpload';
import BjDialogTable from './BjDialogTable';
import BjDialog from './BjDialog';
import BjDateTimerPicker from './BjDateTimerPicker';
import BjDatePicker from './BjDatePicker';
import BjDateRangePicker from './BjDateRangePicker';
import BjDateTimerangePicker from './BjDateTimerangePicker';
import BjCopyIcon from './BjCopyIcon';
import BjTextarea from './BjTextarea';
import BjTooltip from './BjTooltip';

// 编码组件
import BjInputCode from './BjInputCode';
import BjTag from './BjTag';
import BjTagList from './BjTagList';

const components = [
  BjImportFile,
  BjDialogList,
  BjDivider,
  BjDrawerForm,
  BjSelectLov,
  BjCheckboxLov,
  BjRadioLov,
  BjRouteTabs,
  BjInputMoney,
  BjInput,
  ScrollSelect,
  BjPagingTable,
  BjSelectProvinces,
  BjInputNumber,
  BjSelectChinaArea,
  BjUpload,
  BjDialogTable,
  BjDialog,
  BjDateTimerPicker,
  BjDatePicker,
  BjDateRangePicker,
  BjDateTimerangePicker,
  BjInputCode,
  BjTag,
  BjTagList,
  BjCopyIcon,
  BjTextarea,
  BjTooltip
];
const version = '1.4.0';
const install = function(Vue, opts = {}) {
  components.forEach(component => {
    if (component.name) {
      Vue.component(component.name, component);
    }
  });
  // Vue.prototype.$loading = Loading.service;
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: version,
  install,
  BjImportFile,
  BjDialogList,
  BjDivider,
  BjDrawerForm,
  BjSelectLov,
  BjRouteTabs,
  BjInputMoney,
  ScrollLoad,
  ScrollSelect,
  BjPagingTable,
  BjSelectProvinces,
  BjInputNumber,
  BjSelectChinaArea,
  BjUpload,
  BjDialogTable,
  BjDialog,
  BjInputCode,
  BjCopyIcon,
  BjTextarea,
};
